import { useMutation, gql } from '@apollo/client';

import {
  DesalocarProfessorMutation,
  DesalocarProfessorMutationVariables,
} from './__generated__/DesalocarProfessorMutation';

const DESALOCAR_PROFESSOR_MUTATION = gql`
  mutation DesalocarProfessorMutation($id_alocacao: Int!) {
    desalocarProfessor(id_alocacao: $id_alocacao) {
      id_alocacao
    }
  }
`;

const useDesalocarProfessorMutation = () => {
  return useMutation<DesalocarProfessorMutation, DesalocarProfessorMutationVariables>(
    DESALOCAR_PROFESSOR_MUTATION
  );
};

export { useDesalocarProfessorMutation };
